import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93b11130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.IconNoData,
      class: "icon"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", null, _toDisplayString(_ctx.description), 1)
  ]))
}